function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import AppMenuSearchBox from "../containers/AppMenuSearchBox";
import AppMenuSearchResult from "../containers/AppMenuSearchResult";
import AppMenuChapter from "../containers/AppMenuChapter";
import ErrorBoundary from "./ErrorBoundary";
import { FocusOn } from "react-focus-on";
import { CSSTransition } from "react-transition-group";
import eventBus from "../utils/eventBus";
import Icon from "./Icon";
var AppMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AppMenu, Component);
    var _super = _createSuper(AppMenu);
    function AppMenu() {
        _classCallCheck(this, AppMenu);
        var _this;
        _this = _super.apply(this, arguments);
        _this._onToggleMenu = function() {
            var _this_props = _this.props, visible = _this_props.visible, toggleMenu = _this_props.toggleMenu;
            toggleMenu(!visible);
        };
        return _this;
    }
    var _proto = AppMenu.prototype;
    _proto.componentDidMount = function componentDidMount() {
        eventBus.register("Escape", "menu", this._onToggleMenu);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        eventBus.unregister("Escape", "menu");
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var visible = this.props.visible;
        if (prevProps.visible !== visible && visible) {
            eventBus.setScope("menu");
        }
        if (prevProps.visible !== visible && !visible) {
            eventBus.usePrevScope();
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, name = _this_props.name, visible = _this_props.visible, intl = _this_props.intl, nodes = _this_props.nodes, hasResult = _this_props.hasResult;
        return /*#__PURE__*/ React.createElement(CSSTransition, {
            in: visible,
            timeout: 300,
            classNames: "app-menu"
        }, /*#__PURE__*/ React.createElement("section", {
            className: "app-menu",
            style: {
                visibility: visible ? "visible" : "hidden"
            },
            "aria-label": intl.formatMessage({
                id: "ui.menu_label",
                defaultMessage: "Side menu"
            })
        }, /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(FocusOn, {
            enabled: visible,
            className: "app-menu__wrapper",
            noIsolation: true,
            autoFocus: true
        }, /*#__PURE__*/ React.createElement("p", {
            className: "app-menu__header",
            dangerouslySetInnerHTML: {
                __html: name
            }
        }), /*#__PURE__*/ React.createElement(AppMenuSearchBox, null), /*#__PURE__*/ React.createElement("div", {
            className: "app-menu__results",
            id: "app-menu__results"
        }, hasResult && /*#__PURE__*/ React.createElement(AppMenuSearchResult, null), !hasResult && /*#__PURE__*/ React.createElement("nav", null, /*#__PURE__*/ React.createElement("ul", {
            className: "app-menu__chapters"
        }, nodes.map(function(n, i) {
            return /*#__PURE__*/ React.createElement(AppMenuChapter, {
                chapter: n,
                nodeId: n,
                chapterIndex: [
                    i + 1
                ],
                key: n
            });
        })))), /*#__PURE__*/ React.createElement("button", {
            className: "close-btn",
            onClick: this._onToggleMenu,
            "aria-label": intl.formatMessage({
                id: "ui.hide_menu",
                defaultMessage: "Hide menu"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "close-menu",
            size: "s"
        }))))));
    };
    return AppMenu;
}(Component);
AppMenu.defaultProps = {
    nodes: []
};
export default injectIntl(AppMenu);
